import { APICurrentUser } from '@ardoq/api-types';
import { currentUser as CurrentUser } from '../../models/currentUser';
import { setLocaleFromUserSettings } from '../../utils/localeUtils';
import { internalUseOnlyNextCurrentUser } from './currentUser$';

/**
 * App level initialization of current user.
 * Handles initializing and syncing the Backbone based CurrentUser model as
 * well as the currentUser$ stream.
 */
export const initializeCurrentUser = (user: APICurrentUser) => {
  // Set the value in the rxjs Subject as soon as possible, making it safe for
  // use in currentUserInterface and making the first emit when startReducing()
  // is called contain the user data.
  internalUseOnlyNextCurrentUser(structuredClone(user));

  // Manually set the current user model since we fetched it ourselves
  CurrentUser.set(structuredClone(user));
  CurrentUser.loaded = true;
  CurrentUser.trigger('sync');
  CurrentUser.trigger('loaded');

  // Set locale from user settings on CurrentUser
  setLocaleFromUserSettings(user);
};
